module.exports = __webpack_public_path__ + "img/program.bb9cba00.svg";